import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";

export type InstitutionGateway = {
	id: string;
	name: string;
	code?: string;
	calendar?: string;
	address?: string;
	phone?: string;
	web?: string;
	data?: any;
	municipality: {
		id: string;
		name: string;
		gagem: {
			id: string;
			name: string;
		}
	}
};

@Injectable({
	providedIn: 'root'
})
export class InstitutionsGatewayService {
	private baseUrl: string = environment.gatewayURL;

	constructor(private http: HttpClient) {}

	getAll(): Observable<InstitutionGateway[]>{
		return this.http.post<{
			data: {
				data: InstitutionGateway[],
				count: number
			}
		}>(`${this.baseUrl}/v1/institution`, {}).pipe(
			map(response => response.data.data)
		);
	}
}